import React from "react"
import { LayoutContextProvider } from "~layout/contexts/layout"
import ConsentBanner from "~common/components/ConsentBanner"
import EnvironmentBanner from "~common/components/EnvironmentBanner"
import Header from "~layout/components/Header"
import SideBar from "~layout/components/SideBar"
import Main from "~layout/components/Main"
import Footer from "~layout/components/Footer"

const Layout = ({ children, pageContext }) => {
  return (
    <LayoutContextProvider>
      <EnvironmentBanner />
      {pageContext?.layout === "landing" ? (
        children
      ) : (
        <>
          <ConsentBanner />
          <Header />
          <SideBar />
          <Main>{children}</Main>
          <Footer />
        </>
      )}
    </LayoutContextProvider>
  )
}

export default Layout
